import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import ScrollToTop from "./scollToTop";
import { Outlet } from "react-router-dom";

export default function Layout() {
    return (
        <div className="grid min-h-[100dvh] grid-rows-layout bg-white text-slate-800 dark:bg-slate-900 dark:text-slate-200">
            <ScrollToTop />
            <Header />

            <div>
                <Outlet />
            </div>

            <Footer />
        </div>
    );
}
